import { useRouter } from 'next/router';

export const usePdfHelpers = () => {
  const router = useRouter();

  return {
    isPdf: router?.asPath.includes('/pdf/'),
  };
};
